import { COMPONENTS } from '../../../components/components.registry';
import { EmpathizeConfig } from '../../../models';
import { DeepPartial } from '../../../utils';

export const DEFAULT_EMPATHIZE_CONFIG: DeepPartial<EmpathizeConfig> = {
  components: {
    panel: COMPONENTS.PANELS.EmpathizePanel
  }
};
